import React from 'react';

const ReactTicker = () => {
    const currentDate = new Date();
    const targetDate = new Date('2024-10-01');
    return (
        <marquee behavior="scroll" direction="left" className="bg-[#0073BB] text-sm pt-0.5 text-white">
            <pre>Tata AIA, No. 1 in MDRT in 2024, for 3 consecutive years   •   2200 qualifiers in 2024   •   51% women qualifiers   •   Best financial advice a customer can ask for  {currentDate < targetDate ? ` •   Our Savings and Retirement plans will undergo revisions w.e.f. 30th September 2024` : ""}</pre>
        </marquee>
    );
}

export default ReactTicker;
